/*
  This whole component needs attention, linting included.
*/

/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/sort-comp */

import React from 'react'
import actioncable from 'actioncable'
import PropTypes from 'prop-types'

export class ActionCableProvider extends React.Component {
  constructor(props, context) {
    super(props, context)
    // this.displayName = 'ActionCableProvider'
  }

  getChildContext() {
    return {
      cable: this.cable,
    }
  }

  UNSAFE_componentWillMount() {
    if (this.props.cable) {
      this.cable = this.props.cable
    } else {
      this.cable = actioncable.createConsumer(this.props.url)
    }
  }

  UNSAFE_componentWillUnmount() {
    if (!this.props.cable && this.cable) {
      this.cable.disconnect()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // Props not changed
    if (
      this.props.cable === nextProps.cable &&
      this.props.url === nextProps.url
    ) {
      return
    }

    // cable is created by self, disconnect it
    this.componentWillUnmount()

    // create or assign cable
    this.componentWillMount()
  }

  render() {
    return this.props.children
  }
}

ActionCableProvider.propTypes = {
  cable: PropTypes.object,
  url: PropTypes.string,
  children: PropTypes.any,
}

ActionCableProvider.childContextTypes = {
  cable: PropTypes.object.isRequired,
}

ActionCableProvider.displayName = 'ActionCableProvider'

export class ActionCable extends React.Component {
  constructor(props, context) {
    super(props, context)
  }

  componentDidMount() {
    const self = this
    const _props = this.props
    const onReceived = _props.onReceived
    const onInitialized = _props.onInitialized
    const onConnected = _props.onConnected
    const onDisconnected = _props.onDisconnected
    const onRejected = _props.onRejected
    this.cable = this.context.cable.subscriptions.create(this.props.channel, {
      received(data) {
        onReceived && onReceived(data)
      },
      initialized() {
        onInitialized && onInitialized()
      },
      connected() {
        onConnected && onConnected()
      },
      disconnect() {
        onDisconnected && onDisconnected()
      },
      rejected() {
        onRejected && onRejected()
      },
    })
  }

  componentWillUnmount() {
    if (this.cable) {
      this.context.cable.subscriptions.remove(this.cable)
      this.cable = null
    }
  }

  send(data) {
    if (!this.cable) {
      throw new Error('ActionCable component unloaded')
    }

    return this.cable.send(data)
  }

  perform(action, data) {
    if (!this.cable) {
      throw new Error('ActionCable component unloaded')
    }

    return this.cable.perform(action, data)
  }

  render() {
    return null
  }
}

ActionCable.displayName = 'ActionCable'

ActionCable.propTypes = {
  onReceived: PropTypes.func,
  onInitialized: PropTypes.func,
  onConnected: PropTypes.func,
  onDisconnected: PropTypes.func,
  onRejected: PropTypes.func,
}
ActionCable.contextTypes = {
  cable: PropTypes.object.isRequired,
}
